// extracted by mini-css-extract-plugin
module.exports = {"lowerfooter":"styles_lowerfooter__1PH4j","legales":"styles_legales__tYcqZ"};